import React, { useState, useRef } from 'react'
import 'react-placeholder/lib/reactPlaceholder.css'
import Link from 'next/link'

// next components
import Image from 'next/image'

// custom functions
import { useViewport } from 'utils'
import { useDispatch } from 'react-redux'

// images and icons
import DefaultNftBG from 'assets/images/default-nft-bg.png'
import PlayVideoIcon from 'assets/icons/play-video.svg'
import PauseVideoIcon from 'assets/icons/pause-video.svg'
import SingleLiveIcon from 'assets/icons/single-live-icon.svg?component'
import EditionIcon from 'assets/icons/edition-icon.svg?component'
import SolanaLogoIcon from 'assets/icons/solana-logo-gray-14x12.svg?component'
import ThreeDotIcon from 'assets/icons/three-dot-icon.svg?component'

// styles
import styles from './index.module.scss'
import { formattedAmount, categorizeNFT } from 'utils/helpers'

import ImageWithFoster from 'components/ImageWithFoster'
import { getDisplayUserName } from 'utils/strings'

// apis
import nftAPI from 'apis/nfts'
import SocialShareModal from 'components/Menu/SocialShareModal'
import NftCardMenuModal from 'components/Modal/NftCardMenuModal'
import NftCardMenuPage from 'components/Menu/NftCardMenuPage'
import useClickOutside from 'components/Menu/ClickOutsideMenu'

const HomeNftCard = props => {
  const {
    token_id,
    image,
    nftName,
    coverImage = '',
    fallBack = '',
    artistName,
    artistImage = null,
    collectionName,
    assetType,
    price,
    currentSupply,
    maxSupply = '0',
    parentNft = null,
    onClick,
    isOwn = false,
    cardType = 'artwork',
    unSave = null,
  } = props
  const viewport = useViewport()
  const dispatch = useDispatch()
  const [play, setPlay] = useState(false)
  const [displayHideConfirm, setDisplayHideConfirm] = useState(false)
  const [displayUnhideConfirm, setDisplayUnhideConfirm] = useState(false)
  const [showNftMenu, setShowNftMenu] = useState(false)
  const [openShareModal, setOpenShareModal] = useState(false)
  const [hover, setHover] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const nftWidth = 600
  const nftType = categorizeNFT(parentNft, maxSupply)

  const performHideNft = () => {
    setIsLoading(true)

    nftAPI.hideNft(token_id).then(
      response => {
        setIsLoading(false)
        setDisplayHideConfirm(false)
        dispatch({ type: 'set', hideNftToken: token_id })
      },
      error => {}
    )
  }

  const performUnhideNft = () => {
    setIsLoading(true)

    nftAPI.unhideNft(token_id).then(
      response => {
        setIsLoading(false)
        setDisplayUnhideConfirm(false)
        dispatch({ type: 'set', unhideNftToken: token_id })
      },
      error => {}
    )
  }

  const menuRef = useRef(null)

  useClickOutside(menuRef, () => {
    if (viewport === 'lg' || viewport === 'xl' || viewport === '2xl') {
      setShowNftMenu(false)
    }
  })

  return (
    <div className={styles.layout} onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
      <div className={styles.container}>
        <div className={styles.containerCard}>
          <div className={styles.imageArea}>
            {assetType?.includes('video') ? (
              <div className={styles.imageContent}>
                {viewport === 'xs' || viewport === 'sm' || viewport === 'md' ? (
                  <div className="w-full relative flex justify-center items-center overflow-hidden">
                    <Link href={`${window.origin}/nft/${token_id}`} passHref>
                      <a className="w-full h-full">
                        {play ? (
                          <div
                            className="w-full h-full absolute"
                            dangerouslySetInnerHTML={{
                              __html: `<video autoplay loop muted webkit-playsinline playsinline class="w-full h-full object-contain overflow-hidden">
                <source src=${image} type="video/mp4" /></video>`,
                            }}
                          />
                        ) : coverImage != null && coverImage !== '' && !coverImage?.includes('mp4') ? (
                          <ImageWithFoster
                            width={nftWidth}
                            src={coverImage}
                            alt=""
                            className="w-full h-full object-contain"
                          />
                        ) : (
                          <div
                            className="w-full h-full absolute"
                            dangerouslySetInnerHTML={{
                              __html: `<video id="hidden_video" muted webkit-playsinline playsinline class="w-full h-full object-contain overflow-hidden">
                <source src=${image} type="video/mp4" /></video>`,
                            }}
                          />
                        )}
                      </a>
                    </Link>
                    <div className={styles.playButton}>
                      <div className={`${play ? 'w-[18px]' : 'w-[22px]'} h-[18px] flex justify-end`}>
                        <Image
                          src={play ? PauseVideoIcon : PlayVideoIcon}
                          width={18}
                          height={18}
                          alt=""
                          onClick={() => setPlay(!play)}
                        />
                      </div>
                    </div>
                  </div>
                ) : (
                  <Link href={`${window.origin}/nft/${token_id}`} passHref>
                    <a>
                      <div className="w-full h-full" onClick={() => onClick()}>
                        <video src={image} loop muted autoPlay className="w-full h-full object-cover overflow-hidden" />
                      </div>
                    </a>
                  </Link>
                )}
              </div>
            ) : (
              <Link href={`${window.origin}/nft/${token_id}`} passHref>
                <a>
                  <div className={styles.imageContent}>
                    <div className="w-full h-full">
                      {assetType?.includes('vr') ? (
                        coverImage !== null && coverImage !== '' ? (
                          <ImageWithFoster src={coverImage} width={nftWidth} className="w-full h-full object-contain" />
                        ) : (
                          <Image src={DefaultNftBG} alt="" className={styles.imageNft} onClick={() => onClick()} />
                        )
                      ) : assetType?.includes('audio') ? (
                        coverImage !== null && coverImage !== '' ? (
                          <ImageWithFoster
                            src={coverImage}
                            width={nftWidth}
                            onClick={onClick}
                            className="w-full h-full object-contain"
                          />
                        ) : (
                          <Image
                            src={DefaultNftBG}
                            alt=""
                            className="w-full h-full object-contain"
                            onClick={() => onClick()}
                          />
                        )
                      ) : coverImage !== null && coverImage !== '' ? (
                        <ImageWithFoster
                          src={coverImage}
                          width={nftWidth}
                          originalSrc={fallBack}
                          onClick={onClick}
                          className="w-full h-full object-contain"
                        />
                      ) : image !== null && image !== '' ? (
                        <ImageWithFoster
                          src={image}
                          width={nftWidth}
                          originalSrc={fallBack}
                          onClick={onClick}
                          className="w-full h-full object-contain"
                        />
                      ) : (
                        <Image src={DefaultNftBG} alt="" className={styles.imageNft} onClick={() => onClick()} />
                      )}
                    </div>
                  </div>
                </a>
              </Link>
            )}
          </div>

          <div className={`${styles.bottomSection}`}>
            <div className="w-full">
              {cardType === 'artwork' && (
                <div className="w-full flex justify-between items-center">
                  <div className="flex gap-[8px] items-center">
                    {nftType === '1 of 1' ? <SingleLiveIcon /> : <EditionIcon />}
                    <div className={styles.nftType}>{nftType}</div>
                  </div>
                </div>
              )}

              <div ref={menuRef} className="relative w-full flex flex-col mt-[8px]">
                <Link href={`/nft/${token_id}`} passHref>
                  <a className="w-fit">
                    <div className={styles.nftNameForHome}>{nftName}</div>
                  </a>
                </Link>
                {showNftMenu && (viewport === 'lg' || viewport === 'xl' || viewport === '2xl') && (
                  <NftCardMenuPage
                    shareArtwork={() => {
                      setShowNftMenu(false)
                      setOpenShareModal(true)
                    }}
                    isOwn={isOwn}
                    cardType={cardType}
                    hideArtwork={() => {
                      setShowNftMenu(false)
                      performHideNft()
                    }}
                    unhideArtwork={() => {
                      setShowNftMenu(false)
                      performUnhideNft()
                    }}
                    unSave={() => {
                      setShowNftMenu(false)
                      unSave()
                    }}
                    isOnlyShare={price ? true : false}
                  />
                )}
                <div className="w-full flex h-[24px] overflow-visible items-center justify-between">
                  <div className={styles.artistName}>
                    <Link href={`/${artistName}`} passHref>
                      <a>{getDisplayUserName(artistName) || collectionName || 'Ecosystem Artist'}</a>
                    </Link>
                  </div>

                  <div
                    className="w-[32px] h-[32px] flex justify-center items-center"
                    onClick={() => setShowNftMenu(!showNftMenu)}
                  >
                    <div className={showNftMenu ? styles.ellipseContainer : styles.ellipseHover}>
                      <ThreeDotIcon alt="" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="w-full flex justify-between items-center">
                {price ? (
                  <div>
                    <div className="flex justify-center items-center mt-[15px] gap-[5px]">
                      <SolanaLogoIcon />
                      <div>
                        <div className={styles.priceHome}>{formattedAmount(price)}</div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div></div>
                )}
                {!parentNft && price && (
                  <div>
                    {maxSupply === null ? (
                      <div>
                        <div className={`${styles.bidCount} mt-[7px]`}>{currentSupply + ' sold'}</div>
                      </div>
                    ) : parseInt(maxSupply) > 0 ? (
                      <div>
                        <div className={`${styles.bidCount} mt-[7px]`}>
                          {maxSupply - currentSupply + '/' + maxSupply + ' left'}
                        </div>
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* {displayHideConfirm && (
        <div className={styles.hideConfirm}>
          {isLoading ? (
            <div className={styles.loading}>
              <LoadingModal open={isLoading} />
            </div>
          ) : (
            <div className="flex h-full items-center justify-center">
              <div>
                <div className={styles.hideText}>
                  This action will hide the artwork from your profile page.
                  <br />
                  <br />
                  Would you like to proceed?
                </div>
                <div className="flex gap-[15px] lg:gap-[19px] mt-[50px] justify-center">
                  <div className={styles.hideCancelButton} onClick={() => setDisplayHideConfirm(false)}>
                    Cancel
                  </div>
                  <div className={styles.hideButton} onClick={() => performHideNft()}>
                    <div className="flex gap-[6px]">
                      <div className={styles.hideButtonText}>Hide</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )} */}

      {/* {displayUnhideConfirm && (
        <div className={styles.hideConfirm}>
          {isLoading ? (
            <div className={styles.loading}>
              <LoadingModal open={isLoading} />
            </div>
          ) : (
            <div className="flex h-full items-center justify-center">
              <div>
                <div className={styles.hideText}>
                  This artwork is currently hidden from your profile page.
                  <br />
                  <br />
                  Would you like to unhide it?
                </div>
                <div className="flex gap-[6px] lg:gap-[19px] mt-[50px] justify-center">
                  <div className={styles.hideCancelButton} onClick={() => setDisplayUnhideConfirm(false)}>
                    Cancel
                  </div>
                  <div className={styles.hideButton} onClick={() => performUnhideNft()}>
                    <div className="flex gap-[6px]">
                      <Image src={UnhideSmallIcon} alt="" />
                      <div className={styles.hideButtonText}>Unhide</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )} */}

      {openShareModal && (
        <SocialShareModal
          open={openShareModal}
          close={() => setOpenShareModal(false)}
          vote={true}
          message={'Check out this artist on Foster Marketplace @foster_protocol #fostermarketplace'}
          url={`/nft/${token_id}`}
        />
      )}

      {showNftMenu && (viewport === 'xs' || viewport === 'sm' || viewport === 'md') && (
        <NftCardMenuModal
          open={showNftMenu}
          onClose={() => setShowNftMenu(false)}
          isOwn={isOwn}
          shareArtwork={() => {
            setShowNftMenu(false)
            setOpenShareModal(true)
          }}
          hideArtwork={() => {
            setShowNftMenu(false)
            performHideNft()
          }}
          unhideArtwork={() => {
            setShowNftMenu(false)
            performUnhideNft()
          }}
          unSave={() => {
            setShowNftMenu(false)
            unSave()
          }}
          cardType={cardType}
          isOnlyShare={price ? true : false}
        />
      )}
    </div>
  )
}

export default HomeNftCard
